import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { ERROR_MESSAGES } from "../../../components/common/GlobalMassssage";
import { FrequencyEnum, globalSelectStyles } from "../../../middleware/enum";
import SuccessModal from "../../../components/common/SuccessModal";
import { AuthContext, LoaderContext } from "../../../Context/ContextFunctions";
import {
  AddUpdateServiceJob,
  GetServiceJobModel,
} from "../../../services/ServiceJobType/ServiceJobTypeApi";
import Utils from "../../../middleware/Utils";

const AddUpdateJobTypeModal = ({
  isOpen,
  onClose,
  setIsAddUpdateDone,
  modelRequestData,
}) => {
  // Single state for the form fields
  const ModuleName = "Predefined";
  const [jobDataObj, setJobDataObj] = useState({
    jobName: "",
    frequencyID: null,
    customDate: "",
  });
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const { authDetails } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);

  useEffect(() => {
    setModelAction(modelRequestData.Action === null ? "Add" : "Update"); //Do not change this naming convention
    if (
      modelRequestData.KeyID !== undefined &&
      modelRequestData.KeyID !== null &&
      modelRequestData.Action === "Update"
    ) {
      GetServiceJobModelData(modelRequestData.KeyID);
    } else {
      setRequireErrorMessage(false);
      setJobDataObj({
        jobName: "",
        frequencyID: "",
        customDate: "",
      });
    }
    setErrorMessage("");
  }, [modelRequestData]);

  //Get Model
  const GetServiceJobModelData = async (KeyID) => {
    setLoader(true);
    const data = await GetServiceJobModel(
      ModuleName,
      KeyID,
      authDetails.adminKeyID
    );
    if (data.statusCode === 200) {
      setLoader(false);
      const ModalData = data.responseData.data;
      setJobDataObj({
        jobName: ModalData.serviceJobName,
        frequencyID: ModalData.frequencyID,
        customFrequencyDate: ModalData.customFrequencyDate,
      });
    } else {
      setLoader(false);
    }
  };
  // Generic handler for inputs
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Capitalize the first letter if the input is not empty
    let formattedValue = value;
    if (formattedValue.length > 0) {
      formattedValue =
        formattedValue.charAt(0).toUpperCase() + formattedValue.slice(1);
    }

    // Allow only letters at the start, then letters & spaces after the first character
    if (/^[A-Za-z][A-Za-z\s]*$/.test(formattedValue) || formattedValue === "") {
      setJobDataObj((prevState) => ({
        ...prevState,
        [name]: formattedValue,
      }));
    }
  };
  const handleSaveJob = async () => {
    if (
      jobDataObj.jobName === undefined ||
      jobDataObj.jobName === null ||
      jobDataObj.jobName === "" ||
      jobDataObj.frequencyID === undefined ||
      jobDataObj.frequencyID === null ||
      jobDataObj.frequencyID === "" ||
      (jobDataObj.frequencyID === FrequencyEnum.Custom &&
        (jobDataObj.customDate === undefined ||
          jobDataObj.customDate === "" ||
          jobDataObj.customDate === null))
    ) {
      setRequireErrorMessage(true);
      return false;
    }
    setLoader(true);
    try {
      const data = await AddUpdateServiceJob({
        adminKeyID: authDetails.adminKeyID,
        customerKeyID: authDetails.customerKeyID,
        serviceKeyID: modelRequestData.serviceKeyID,
        serviceJobKeyID: modelRequestData.KeyID,
        serviceJobName: jobDataObj.jobName,
        frequencyID: jobDataObj.frequencyID,

        customFrequencyDate:
          jobDataObj.frequencyID == FrequencyEnum.Custom
            ? jobDataObj.customFrequencyDate
            : null,
        ModuleName: ModuleName,
      });
      if (data?.statusCode === 200) {
        setLoader(false);
        setIsAddUpdateDone(true);
        setShowSuccessPopupModal(true);
      } else {
        setLoader(false);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
    }
  };
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 px-4">
      {/* Background Overlay */}
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>

      {/* Modal Box */}
      <div className="bg-white rounded-lg shadow-lg z-10 w-full max-w-[90%] sm:w-1/3">
        {/* Header */}
        <div className="bg-[#ECF6FF] px-6 py-4 rounded-t-lg border-b">
          <h2 className="text-sm sm:text-base font-semibold text-gray-800">
            {modelAction} Job
          </h2>
        </div>

        {/* Body */}
        <div className="p-6 sm:p-8 space-y-4">
          {/* Job Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Job Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              name="jobName"
              value={jobDataObj.jobName}
              maxLength={150}
              onChange={handleChange}
              className="w-full p-2 border rounded-md text-12"
              placeholder="Enter Job"
            />
            {requireErrorMessage &&
            (jobDataObj.jobName === "" ||
              jobDataObj.jobName === undefined ||
              jobDataObj.jobName === null) ? (
              <label className="validation">{ERROR_MESSAGES}</label>
            ) : (
              ""
            )}
          </div>

          {/* Frequency */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Frequency <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              options={Utils.frequencyOptions}
              value={
                Utils.frequencyOptions.find(
                  (item) => item.value === jobDataObj.frequencyID
                ) || null
              }
              onChange={(selectedOption) =>
                setJobDataObj({
                  ...jobDataObj,
                  frequencyID: selectedOption.value,
                })
              }
              menuLimenuPlacement="top"
              styles={globalSelectStyles}
            />
            {requireErrorMessage &&
            (jobDataObj.frequencyID === "" ||
              jobDataObj.frequencyID === undefined ||
              jobDataObj.frequencyID === null) ? (
              <label className="validation">{ERROR_MESSAGES}</label>
            ) : (
              ""
            )}
          </div>

          {/* Custom Date (show if frequencyID is custom) */}
          {jobDataObj.frequencyID === FrequencyEnum.Custom && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Select Date <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="date"
                name="customDate"
                value={jobDataObj.customDate}
                onChange={handleChange}
                className="w-full p-2 border rounded-md text-12"
              />
              {requireErrorMessage &&
              ((jobDataObj.frequencyID === FrequencyEnum.Custom &&
                jobDataObj.customDate === "") ||
                jobDataObj.customDate === undefined ||
                jobDataObj.customDate === null) ? (
                <label className="validation">{ERROR_MESSAGES}</label>
              ) : (
                ""
              )}
            </div>
          )}
        </div>

        {errorMessage && (
          <div className="text-center mb-2">
            <label className="validation ">{errorMessage}</label>
          </div>
        )}

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 rounded-b-lg border-t flex justify-end gap-3">
          <button
            type="button"
            className="px-4 py-2 bg-gray-300 rounded-md text-sm"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-sm"
            onClick={() => handleSaveJob()}
          >
            Submit
          </button>
        </div>
      </div>
      <SuccessModal
        isOpen={showSuccessPopupModal}
        onClose={() => {
          onClose();
          setShowSuccessPopupModal(false);
        }}
        modelAction={modelAction}
        actionMessage={jobDataObj.jobName}
      />
    </div>
  );
};

export default AddUpdateJobTypeModal;
